import { Box, BoxProps, Icon, ModalDialog, Spacer, Text } from '@jfs/ui-new'
import { useState } from 'react'
import { useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { ruleTitles } from '../../utils/constants'
import { getTextView } from '../EntityMaster/EntityDetails'
import { RoutingRulesForm } from './RoutingRulesForm'

const RuleDetails = (props: any) => {
  const { route } = props
  const { id } = route?.params ?? ''
  localStorage.setItem('params', id)
  console.log({ id })

  const [isModal, setModal] = useState(false)
  const [updateData, setUpdateData] = useState({})

  const { details, entityIdMap, accessConfig } = useStores((store) => ({
    details: store.routingRule.getRuleDetails,
    entityIdMap: store.entityMaster.entityIdNames,
    accessConfig: store.user.getAccessConfig(['static_routing', 'rules']),
  }))

  const handleEdit = () => {
    console.log(entityIdMap, entityIdMap[0])

    try {
      const data = details(+id)
      const binRange = data.binRange?.split(',')
      const filterD = entityIdMap.filter((item) => item.id === data?.transactionInitiatingEntityId)
      const entityId = filterD.length && filterD[0]
      const amountRange = data.amount?.split(',')
      setUpdateData({
        ...data,
        binFrom: binRange[0],
        binTo: binRange[1],
        transactionInitiatingEntityId: entityId
          ? `${entityId.id}-${entityId.name}`
          : data?.transactionInitiatingEntityId,
        minAmount: amountRange[0],
        maxAmount: amountRange[1],
      })
    } catch (e) {
      console.log({ e })
    }
    setModal(true)
  }

  const closeForm = () => {
    setUpdateData({})
    setModal(false)
  }

  return (
    <Box>
      <Box {...styles.container}>
        <Text fontSize={18} fontFamily={'jiotype-bold'} color={'BLACK_21'}>{`Details for Rule ID: ${id}`}</Text>
        <Box flexDirection="row" alignSelf="flex-end">
          {isAccessible(accessConfig, 'update') && (
            <Box {...styles.edit} onPress={handleEdit}>
              <Icon id="EDIT" size="FONT_SIZE_LARGE" color="WHITE" />
              <Spacer direction="horizontal" size={4} />
              <Text color="WHITE">Edit/Delete</Text>
            </Box>
          )}
        </Box>
      </Box>
      <Box flexDirection="row" flexWrap="wrap" paddingHorizontal={24} backgroundColor="WHITE">
        {getTextView(details(+id), ruleTitles)}
      </Box>
      <ModalDialog
        children={
          <RoutingRulesForm
            initialData={updateData}
            id={id}
            isDeletable={isAccessible(accessConfig, 'delete')}
            isEditable={isAccessible(accessConfig, 'update')}
            onUpdate={closeForm}
            onClose={closeForm}
          />
        }
        show={isModal}
        type={'Right'}
      />
    </Box>
  )
}

export default RuleDetails

const styles = {
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'BACKGROUND_LIGHT',
    paddingHorizontal: 24,
    paddingVertical: 16,
  } as BoxProps,
  edit: {
    flexDirection: 'row',
    backgroundColor: 'PRIMARY',
    padding: 8,
    borderRadius: 4,
    underlayColor: 'PRIMARY_STORNG',
  } as BoxProps,
  delete: {
    flexDirection: 'row',
    backgroundColor: 'RED',
    padding: 8,
    borderRadius: 4,
    underlayColor: 'ERROR',
  } as BoxProps,
}
